export default __webpack_public_path__ + "static/media/icon-neutral.b1325c2f.svg";